export default __webpack_public_path__ + "static/media/sc-dress-shirt.514eb1bd.svg";